import React, { useState, useEffect } from "react";
import CopyToClipboard from "react-copy-to-clipboard";

import { PcaSubHeading, PcaHeading } from "../theme/typography";
import { PageActionsContainer } from "../theme/containers";
import { Box } from "../theme/containers";
import { Flexbox } from "../theme/grid";
import {
    PrimaryButton,
    SecondaryButton
} from "../simple-buttons/simple-buttons";
import { StyledTooltip } from "../boi-tooltip/boi-tooltip.styles";
import LoadingIcon from "../loading-icon/loading-icon";
import { SVGInfoIcon, SVGSuccessIcon } from "../svg-animated/svg-animated";
import BoiReactMarkdown from "../boi-markdown/boi-markdown";

const CameraDetectionScreen = (props: any) => {
    const screenType = props.type;
    const isScreenRequestAccess = screenType === "requestAccess";
    const isScreenNoCamera = screenType === "noCamera";
    const [copy, setCopy] = useState(false);

    useEffect(() => {
        copy === true &&
            setTimeout(() => {
                setCopy(false);
            }, 3000);
    }, [copy]);

    const handleTryAgain = () => {
        window.location.reload();
    }

    switch (screenType) {
        case "requestAccess":
        case "success":
            return (
                <div className="u-text-centre u-mt-6 u-pt-6">
                    <Box className="u-mx-auto">
                        {isScreenRequestAccess ? (
                            <SVGInfoIcon />
                        ) : (
                            <SVGSuccessIcon />
                        )}
                    </Box>
                    <PcaHeading className="u-my-6">
                        {isScreenRequestAccess
                            ? "Before you begin, can we check the camera on this device?"
                            : "Camera detected"}
                    </PcaHeading>
                    <PcaSubHeading>
                        {isScreenRequestAccess
                            ? "You'll need the camera to confirm your identity as part of your application."
                            : "Great, you can now use this device's camera to confirm your identity."}
                    </PcaSubHeading>
                    <PageActionsContainer className="block" id="actions">
                        <PrimaryButton
                            onClick={() =>
                                isScreenRequestAccess
                                    ? props.requestAccess()
                                    : props.onAccessGranted()
                            }
                            text={isScreenRequestAccess ? "Check camera" : "Continue"}
                        />
                    </PageActionsContainer>
                </div>
            );
        case "noCamera":
        case "denied":
            return (
                <div className="u-text-centre u-mt-6 u-pt-6">
                    <Box className="u-mx-auto">
                        <SVGInfoIcon />
                    </Box>
                    <PcaHeading className="u-my-6">
                        {isScreenNoCamera
                            ? "No camera detected"
                            : "Looks like your camera won't permit this"}
                    </PcaHeading>
                    <PcaSubHeading>
                        {isScreenNoCamera
                            ? "We couldn't find a camera on this device. You can open the link below on your smartphone instead. It's the fastest way to apply."
                            : "You could adjust your camera settings and try again, or copy the link below and open it on your smartphone instead. It's the easiest way to apply."}
                    </PcaSubHeading>
                    <Flexbox
                        fullHeight
                        flexDirection="column"
                        alignItems="center"
                    >
                        <PcaSubHeading width="100%">
                            <a
                                href={props.copyUrl}
                                className="u-mt-1 u-display-block"
                            >
                                {props.copyUrlLabel}
                            </a>
                        </PcaSubHeading>
                        <CopyToClipboard
                            text={props.copyUrl}
                            onCopy={() => setCopy(true)}
                        >
                            <SecondaryButton
                                small
                                href=""
                                id="copy-to-clipboard"
                                text="Copy link"
                            >
                                <StyledTooltip
                                    placement="top"
                                    isOpen={copy}
                                    trigger="click"
                                    className="boi-tip"
                                    flip={false}
                                    fade={true}
                                    delay={{ show: 0, hide: 0 }}
                                    target={"copy-to-clipboard"}
                                >
                                    <BoiReactMarkdown
                                        disallowedElements={["p"]}
                                        unwrapDisallowed={true}
                                    >
                                        This link has now been copied to your clipboard
                                    </BoiReactMarkdown>
                                </StyledTooltip>
                                Copy link
                            </SecondaryButton>
                        </CopyToClipboard>
                    </Flexbox>
                    <PageActionsContainer className="block" id="actions">
                        <PrimaryButton
                            as="a"
                            id="button-close"
                            href="https://www.bankofireland.com"
                            text="Close"
                        />
                        {!isScreenNoCamera && (
                            <div style={{ marginTop: 20, order: 2 }}>
                                <SecondaryButton
                                    fullWidth
                                    onClick={handleTryAgain}
                                    href={
                                        window.location.pathname +
                                        window.location.search
                                    }
                                    text="Try again"
                                />
                            </div>
                        )}
                    </PageActionsContainer>
                </div>
            );
        case "loading":
        default:
            return <LoadingIcon />;
    }
};

export default CameraDetectionScreen;
